<template>
  <rhcn-drawer @on-close="onClose" v-loading="loading">
    <div class="drawer-form exchange-form" style="width: 637px;">
      <div>
        <rhcn-step :steps="steps" :active="1"></rhcn-step>
      </div>
      <div>
        <div v-if="contactInfo" class="payout-top-box">
          <p class="contact-info-title">
            {{ $t('message.transfer.transferToAct', { payee: contactInfo.bankAccount || '' }) }}
          </p>
          <div class="contact-info-desc">
            <p>{{ $t('message.contact.transferTo') }}</p>
            <p class="contact-country margin-top-6">
              <img v-if="contactInfo.payoutCurrency" class="icon-currency"
                :src="getCurrencyImage(contactInfo.payoutCurrency) ? require(`@/assets/images/currency/${contactInfo.payoutCurrency}.png`) : ''" />
              <span class="margin-left-8">{{ getCountryDesc(contactInfo.bankCountry) }}</span>
            </p>
          </div>
        </div>
        <el-form ref="formRef1" :model="form" class="form-relactive margin-top-25" :rules="formRules"
          label-position="top">
          <!-- you send -->
          <rhcn-currency-amount ref="sendRef" :label="$t('message.transfer.youSend')"
            :placeholder="sendAmountPlaceholder" input-prop="sendAmount" select-prop="sendCurrency"
            :input-value.sync="form.sendAmount" :select-value.sync="form.sendCurrency" :options="sendCurrencyList"
            :option="{ currency: 'value', amount: 'amount' }" @on-input="inputHandler"
            @on-change="onSendCurrencyChange"></rhcn-currency-amount>
          <div class="rate-wrapper" :class="{ 'show-rate': showRate }">
            <div class="line"></div>
            <div class="rate-content">
              <div class="rate-content-item">
                <div class="close-icon">
                  <span class="iconfont icon-jian"></span>
                </div>
                <div class="rate-text">
                  <span class="rate-amount">{{ form.serviceFee }} {{ form.serviceFee ? form.sendCurrency.value :
                    '' }}</span>
                  <span class="time">{{ $t('message.settlement.serviceAmount') }}</span>
                </div>
              </div>
              <template v-if="showRate">
                <div class="rate-content-item margin-top-10">
                  <div class="close-icon">
                    <span class="iconfont icon-dengyu1"></span>
                  </div>
                  <div class="rate-text">
                    <span class="rate-amount">{{ form.exchangeAmount }} {{ form.exchangeAmount ? form.sendCurrency.value
                      :
                      '' }}</span>
                    <span class="time">{{ $t('message.transfer.willEchangeAmount') }}</span>
                  </div>
                </div>
                <div class="rate-content-item margin-top-10">
                  <div class="close-icon">
                    <span class="iconfont icon-huishuai"></span>
                  </div>
                  <div class="rate-text">
                    <span class="rate-amount">{{ form.rate }}</span>
                    <span class="time">
                      {{ `${form.sendCurrency.value}/${form.getCurrency.value} ${$t('message.transfer.rate')}` }}
                      <span v-if="rateCountdown > 0" class="margin-left-20"
                        v-html="$t('message.transfer.validWithin', { time: `${rateCountdown}s` })"></span>
                    </span>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <!-- beneficiary gets -->
          <rhcn-currency-amount ref="sellRef" :label="$t('message.transfer.beneficiaryGets')" input-prop="getAmount"
            select-prop="getCurrency" :input-value.sync="form.getAmount" :select-value.sync="form.getCurrency"
            :input-disabled="merchantType !== 'B2B'" :select-disabled="true" :options="getCurrencyList"
            :option="{ currency: 'value' }" @on-input="inputGetHandler"></rhcn-currency-amount>
          <p class="transfer-tips margin-top-24 margin-bottom-20">{{ $t('message.transfer.transferAmountTips') }}</p>
          <template v-if="showPayer">
            <el-checkbox v-model="isPayerChecked" class="margin-bottom-20">
              <span class="payer-check-label">{{ $t('message.transfer.designatedPayer') }}</span>
            </el-checkbox>
            <el-form-item v-if="isPayerChecked" prop="payer" :label="$t('message.transfer.payer')">
              <el-select v-model="form.payer" clearable filterable>
                <template v-for="(item, index) in payerList">
                  <el-option :key="index" :value="item.id"
                    :label="`${item.holderName}-${item.accountLabel}`"></el-option>
                </template>
              </el-select>
            </el-form-item>
          </template>
        </el-form>
        <div>
          <validation-component ref="formRef3" :validation-condition="conditionspayer">
          </validation-component>
          <div v-if="contactInfo && transferMethodList.length > 0 && txnFieldList.length > 0" class="payout-method-box">
            <SwiftInfo v-show="payoutMethod === 'SWIFT' && transferMethodList.includes('SWIFT')" ref="swiftInfoRef"
              :txnFields="txnFieldList" :contact="contactInfo"></SwiftInfo>
            <BankInfo v-show="payoutMethod === 'BANK_TRANSFER' && transferMethodList.includes('BANK_TRANSFER')"
              ref="bankInfoRef" :txnFields="txnFieldList" :contact="contactInfo"></BankInfo>
            <WalletInfo v-show="payoutMethod === 'E_WALLET' && transferMethodList.includes('E_WALLET')"
              ref="walletInfoRef" :txnFields="txnFieldList" :contact="contactInfo"></WalletInfo>
            <CashInfo v-show="payoutMethod === 'CASH_PICKUP' && transferMethodList.includes('CASH_PICKUP')"
              ref="cashInfoRef" :txnFields="txnFieldList" :contact="contactInfo"></CashInfo>
          </div>
          <validation-component ref="formRef2" :validation-condition="conditions">
          </validation-component>
        </div>
        <el-checkbox v-model="isSaveContactChecked" :disabled="!validatePayoutForm()" class="margin-top-10">
          <span class="payer-check-label">{{ $t('message.transfer.saveContactInfo') }}</span>
        </el-checkbox>
        <div class="margin-top-20 bottom-box-center" style="padding-bottom: 50px;">
          <el-button :disabled="!validateSubmit()" style="width:100%;" type="primary" @click="submit">{{
            $t('message.common.next') }}</el-button>
          <p class="btn-previous margin-top-10" @click="handlePrevious">{{ $t('message.common.previous') }}</p>
        </div>
      </div>
    </div>
  </rhcn-drawer>
</template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';

import RhcnDrawer from '@/components/drawer/index.vue';
import RhcnCurrencyAmount from '@/components/form/currency-amount.vue';
import { ShowWarningMessage, ShowErrorMessage } from '@/components/modal/tips/message-tips';
import RhcnStep from '@/components/step/index.vue';
import { validateFns, REQUIRED, ENGLISH_NAME } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import {
  getCurrencyImage, isValidCurrencyAmount, formatAmountByCurrency,
  CURRENCY_DECIMAL_DIGITS,
} from '@/utils/tools/currency';
import { arr2obj } from '@/utils/tools/utils';
import AccountInfo from '@/views/account/information/api/account-info';
import BalancesService from '@/views/settlement/api/settlement-balance';
import {
  getPayeeInfo, getCountryGroupListByName,
  queryWalletType, queryPayeeFields,
} from '@/views/transfer/api/contact';
import {
  TXN_FIELDS,
} from '@/views/transfer/api/fields';
import TransferService from '@/views/transfer/api/transfer';
import BankInfo from '@/views/transfer/transfer/add/amount/bank-info.vue';
import CashInfo from '@/views/transfer/transfer/add/amount/cash-info.vue';
import SwiftInfo from '@/views/transfer/transfer/add/amount/swift-info.vue';
import WalletInfo from '@/views/transfer/transfer/add/amount/wallet-info.vue';

export default {
  name: 'AmountPayout',
  components: {
    RhcnDrawer,
    RhcnCurrencyAmount,
    RhcnStep,
    ValidationComponent,
    BankInfo,
    WalletInfo,
    CashInfo,
    SwiftInfo,
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
    businessType() {
      return this.$route.query.businessType || null;
    },
  },
  data() {
    return {
      steps: [
        {
          title: 'message.transfer.recipient',
          handler: () => {
            this.$router.push({
              path: '/transfer/transfer/add/recipient',
              query: {
                businessType: this.businessType,
              },
            });
          },
        },
        {
          title: 'message.exchange.amount',
        },
        {
          title: 'message.exchange.review',
        },
      ],
      formRules: {
        payer: [
          { validator: validateFns([REQUIRED]) },
        ],
        sendAmount: [
          // { validator: validateFns([REQUIRED]) },
          { validator: this.validateSendAmount }, // 余额验证
        ],
        getAmount: [
          { validator: this.validateGetAmount }, // 余额验证
        ],
      },
      form: {
        payer: '',
        sendCurrency: '',
        getCurrency: '',
        sendAmount: '',
        getAmount: '',
        serviceFee: '',
        exchangeAmount: '',
        rate: '',
      },
      sendCurrencyList: [],
      getCurrencyList: [],
      conditionspayer: [
        {
          key: 'payerId',
          name: 'message.payoutInfo.payerName',
          type: 'select',
          isHide: true,
          defValue: '',
        },
      ],
      conditions: [
        { // 付款用途
          key: 'transactionPurpose',
          name: 'message.transfer.payoutPurpose',
          type: 'select',
          defValue: '',
          rule: [],
          isShowStar: true,
          validator: this.validateTransactionPurpose,
        },
        // { // 资金来源
        //   key: 'capitalSource',
        //   name: 'message.transfer.fundsSource',
        //   type: 'input',
        //   defValue: '',
        //   rule: [REQUIRED],
        //   isShowStar: true,
        // },
        { // 附言
          key: 'reference',
          name: 'message.transfer.payoutPostscri',
          type: 'input',
          defValue: '',
          rule: [],
          isShowStar: true,
          tipList: [{
            key: '',
            value: this.$t('message.transfer.referenceTips'),
          }],
          validator: this.validateReference,
        },
      ],
      cardInfoId: this.$route.query.id,
      contactInfo: null,
      loading: true,
      txnPurposeList: [],
      // 付款方名称
      payerNameList: [],
      merchantType: 'COMMON', // B2B COMMON
      showPayer: false,
      payerList: [], // 付款方列表
      isPayerChecked: false,
      sendAmountPlaceholder: '',
      registration: '', // 商户注册地
      showRate: false,
      rateCountdown: 0,
      exchangeDirection: 0, // 换汇方向 0: 正向  1: 逆向
      payoutMethod: '',
      isSaveContactChecked: false,
      euCountryMap: {},
      transferMethodList: [],
      defaultSendCurrency: 'USD',
      txnFieldList: [],
      // /**
      // * 支付方式，0: LOCAL; 1: SWIFT; 2 银行转账; 3 钱包; 4 现金支取
      // */
      transferMethodListOptions: [
        {
          label: 'message.contact.accountBank',
          value: 'BANK_TRANSFER',
          code: '2',
        },
        {
          label: 'message.contact.swiftTitle',
          value: 'SWIFT',
          code: '1',
        },
        {
          label: 'message.contact.accountWallet',
          value: 'E_WALLET',
          code: '3',

        },
        {
          label: 'message.contact.accountCash',
          value: 'CASH_PICKUP',
          code: '4',

        },
      ],
    };
  },
  created() {
    const { currency } = this.$route.query;
    if (currency) {
      this.defaultSendCurrency = currency;
    }
  },
  async mounted() {
    // 商户类型
    try {
      const userLogin = this.app.userLogin;
      if (userLogin && (userLogin.businessType === '0' || this.businessType === 'payout')) {
        this.merchantType = 'B2B';
      } else if (userLogin && userLogin.businessType === '2') {
        this.merchantType = 'B2C';
      }
    } catch (error) {
      console.log('get merchant info error in transfer amount', error);
    }
    // 付款方名称列表
    await TransferService.querylistPayer().then((res) => {
      console.log(res, 'res');
      this.payerNameList = res.map(item => ({
        id: item.id,
        value: item.id,
        label: item.companyNameEn,
      }));
      console.log(this.payerNameList, 'guan');
      if (this.payerNameList.length > 0) {
        this.$refs.formRef3.setItemHide('payerId', false);
        this.$refs.formRef3.setValidationSelectOptions('payerId', this.payerNameList);
      }
      // this.txnPurposeList = initSelectedData(txnPurposeList, 'description', 'value', false);
    }).catch(() => ({}));
    const accountInfo = await AccountInfo.getAccountInfo();
    this.registration = accountInfo.country;

    let info;
    try {
      info = JSON.parse(window.sessionStorage.getItem('transferData'));
    } catch (err) {
      //
    }
    let contactInfo;
    if (info && info.contactInfo && info.contactInfo.id === this.cardInfoId) {
      contactInfo = info.contactInfo;
      if (info.payoutMethod) {
        this.payoutMethod = info.payoutMethod;
      }
      if (info.isSavePayee) {
        this.isSaveContactChecked = info.isSavePayee;
      }
    }
    if (this.cardInfoId) { // 兼容 contactInfo 不存在的问题
      // 收款方详情信息
      await getPayeeInfo({ cardInfoId: this.cardInfoId }).then((res) => {
        if (!contactInfo) {
          contactInfo = res;
        } else if (!contactInfo.cardNumber || contactInfo.cardNumber.indexOf('*') > -1) {
          // 更新银行账号信息
          contactInfo.cardNumber = res.cardNumber;
        }
        if (!contactInfo.pickUpBankBranchName) {
          contactInfo.pickUpBankBranchName = res.pickUpBankBranchName;
        }
        if (!contactInfo.bankHolderName) {
          contactInfo.bankHolderName = res.bankHolderName;
        }
        // TODO:默认选中配置的方式
        if (res.paymentMethod) {
          this.payoutMethod = this.transferMethodListOptions.find(item => item.code === res.paymentMethod)?.value;
        }
      }).catch(() => ({}));
    }
    this.contactInfo = contactInfo;

    // 发起币种
    const params = {
      businessType: this.businessType ? (this.businessType === 'payout' ? 'PAYOUT' : 'ACQUIRING') : null,
    };
    console.log(params, 'params', this.businessType);
    const dict = await GlobalData.getDictList(['PAYOUT_SUPPORT_CURRENCY']);
    const supportCurrencyList = dict.PAYOUT_SUPPORT_CURRENCY.map(item => item.value);

    await BalancesService.getAccountBalances(params).then((data) => {
      data.forEach((item) => {
        if (supportCurrencyList.includes(item.availBalance.currency)) {
          this.sendCurrencyList.push({
            value: item.availBalance.currency,
            amount: item.availBalance.amount,
          });
        }
        this.getCurrencyList.push({
          value: item.availBalance.currency,
        });
        if (this.contactInfo.payoutCurrency === item.availBalance.currency) {
          // this.form.sendCurrency = { value: item.availBalance.currency, amount: item.availBalance.amount };
          this.form.getCurrency = { value: item.availBalance.currency };
        }
        if (item.availBalance.currency === this.defaultSendCurrency) { // 默认显示币种
          this.form.sendCurrency = { value: item.availBalance.currency, amount: item.availBalance.amount };
        }
      });
      if (!this.form.sendCurrency && this.sendCurrencyList.length > 0) {
        this.form.sendCurrency = {
          ...this.sendCurrencyList[0],
        };
      }
    }).catch(() => ({}));
    // 付款方列表
    if (this.merchantType === 'B2B') {
      this.showPayer = false;
      // 获取欧洲国家
      const gountryGroupRes = await getCountryGroupListByName({ countryGroupName: 'payment-EU' });
      this.euCountryMap = arr2obj(gountryGroupRes.countryGroupInfos || [], { key: 'value' });
      const payoutCurrency = this.contactInfo.payoutCurrency;
      const bankCountry = this.contactInfo.bankCountry;
      if ((payoutCurrency === 'GBP' || payoutCurrency === 'USD' || payoutCurrency === 'EUR') &&
        (!!this.euCountryMap[bankCountry] || bankCountry === 'GB')) {
        // 20240129 前端隐藏指定付款方功能
        // this.showPayer = true;
      }

      if (this.showPayer) {
        await TransferService.getPayerVaList({ filingStatus: 'Y', applyCurrency: this.form.sendCurrency.value }).then((res) => {
          this.payerList = res;
        }).catch(() => ({}));
      }
    }
    await this.queryPayoutRouteList();
    // 不同币种时显示汇率信息
    this.showRate = this.form.sendCurrency.value !== this.form.getCurrency.value;

    // 字典查询
    await GlobalData.getDictList(['COUNTRY', 'TXN_PURPOSE']).then((res) => {
      this.countryList = initSelectedData((res.COUNTRY || []), 'description', 'value', false);
      let txnPurposeList = [];
      // 交易用途显示 【'转至本人账户', '贷款信贷偿还', '货物贸易', '技术服务/商业服务', '运费', '酬劳/工资', '其他'】
      if (res.TXN_PURPOSE) {
        txnPurposeList = res.TXN_PURPOSE.filter((item) => {
          if (['0', '2', '12', '5', '4', '11', '10'].indexOf(item.value) > -1) {
            return item;
          }
        });
      }
      this.txnPurposeList = initSelectedData(txnPurposeList, 'description', 'value', false);
      console.log(this.txnPurposeList, 'guan');
      this.$refs.formRef2.setValidationSelectOptions('transactionPurpose', this.txnPurposeList);
    }).catch(() => ({}));
    // 初始化已填写的数据
    try {
      if (info && info.cardInfoId === this.cardInfoId && info.getCurrency.value === this.form.getCurrency.value) {
        this.form.payer = info.payer;
        this.form.sendAmount = info.sendAmount;
        this.form.serviceFee = info.serviceFee;
        this.form.getAmount = info.getAmount;
        this.isPayerChecked = (info.isSamePayee === 'Y');
        this.$refs.formRef2.setItemValue('transactionPurpose', info.transactionPurpose);
        // this.$refs.formRef2.setItemValue('capitalSource', info.capitalSource);
        this.$refs.formRef2.setItemValue('reference', info.reference);
        if (info.sendCurrency) {
          this.form.sendCurrency = info.sendCurrency;
          this.showRate = this.form.sendCurrency.value !== this.form.getCurrency.value;
        }
        if (this.showRate) {
          const isReverse = info.exchangeDirection === 1;
          this.getFee({ isReverse, amount: isReverse ? this.form.getAmount : this.form.sendAmount });
        }
      } else {
        this.checkRate();
      }
    } catch (error) {
      console.log('get old info error', error);
    }
    // if (this.form.sendAmount === '' && this.form.sendCurrency) {
    //   this.sendAmountPlaceholder = this.form.sendCurrency.amount;
    // }

    this.loading = false;

    this.debounceGetFee = _.debounce(this.getFee, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    getCurrencyImage,
    onClose() {
      window.sessionStorage.removeItem('transferData');
      if (this.businessType) {
        this.$router.push({
          path: `/transfer/transfer/aggregate/${this.businessType}`,
        });
      } else {
        this.$router.push({
          path: '/transfer/transfer',
        });
      }
    },
    async queryPayoutRouteList() {
      try {
        const { bankCountry, entityType, payoutCurrency } = this.contactInfo;
        const paymentCurrency = this.form.sendCurrency.value;
        if (!bankCountry || !entityType || !payoutCurrency || !paymentCurrency) {
          return;
        }
        this.transferMethodList = [];
        const params = {
          paymentToCountry: bankCountry,
          accountType: entityType,
          payeeCurrency: payoutCurrency,
          paymentCurrency,
        };
        const res = await TransferService.queryPaymentRouteMethod(params);
        if (res.length > 0) {
          this.transferMethodList = res;
          if (this.transferMethodList.length === 1) {
            this.payoutMethod = this.payoutMethod || this.transferMethodList[0];
          } else if (this.transferMethodList.includes('BANK_TRANSFER')) {
            this.payoutMethod = this.payoutMethod || 'BANK_TRANSFER';
          } else if (this.transferMethodList.includes('E_WALLET')) {
            this.payoutMethod = this.payoutMethod || 'E_WALLET';
          } else if (this.transferMethodList.includes('CASH_PICKUP')) {
            this.payoutMethod = this.payoutMethod || 'CASH_PICKUP';
          }

          const fieldsRes = await queryPayeeFields({
            paymentToCountry: bankCountry,
            accountType: entityType,
            payeeCurrency: payoutCurrency,
          });
          if (fieldsRes && fieldsRes.txnFields) {
            this.txnFieldList = TXN_FIELDS.map((item, index) => ({
              key: item.key,
              field: fieldsRes.txnFields[index],
            }));
          } else {
            ShowErrorMessage(this.$t('message.transfer.noTransferFieldsTips'));
          }

          if (this.transferMethodList.includes('E_WALLET')) {
            // 包含钱包类型，则获取钱包信息
            await this.fetchWalletType(params);
          }
        } else {
          ShowErrorMessage(this.$t('message.transfer.noTransferMethodTips'));
        }

        for (let i = 0; i < this.txnFieldList.length; i++) {
          const key = this.txnFieldList[i].key;
          const field = this.txnFieldList[i].field;
          if (key === 'transactionPurpose' || key === 'reference') {
            this.$refs.formRef2.setItemHide(key, field === 'N');
            this.$refs.formRef2.setItemRequire(key, field === 'Y');
          }
        }
      } catch (err) {
        //
      }
    },
    async fetchWalletType(params) {
      const res = await queryWalletType({ ...params });
      const list = res.map(item => ({
        ...item,
        label: item.viewName || item.walletType,
        value: item.walletType,
      }));
      if (this.$refs.walletInfoRef) {
        this.$refs.walletInfoRef.setWalletTypeOptions(list);
      }
    },
    async onSendCurrencyChange() {
      this.showRate = this.form.sendCurrency.value !== this.form.getCurrency.value;
      this.form.rate = '';
      this.rateCountdown = 0;
      this.timer && clearInterval(this.timer);
      this.loading = true;
      try {
        await this.queryPayoutRouteList();
      } catch (err) {
        //
      }
      this.loading = false;
      const isReverse = this.exchangeDirection === 1;
      if (this.transferMethodList.length === 0) { // 当付款方式为空时，不再继续
        return;
      }
      if (isReverse) { // 逆向
        this.inputGetHandler(this.form.getAmount);
      } else {
        this.inputHandler(this.form.sendAmount);
      }
    },
    inputHandler(value) {
      let v = value.match(/^\d*(\.?\d{0,2})/g)[0];
      if (`${CURRENCY_DECIMAL_DIGITS[this.form.sendCurrency.value]}` === '0') {
        // 不存在小数位时，移除
        v = v.split('.')[0];
      }
      this.form.sendAmount = v;
      this.$refs.sendRef.inputInnerValue = v;
      this.form.serviceFee = '';
      this.form.exchangeAmount = '';
      this.form.getAmount = '';
      // 付款金额placeholder
      // if (!isNaN(this.sendAmountPlaceholder) && this.form.sendAmount !== '') {
      //   this.sendAmountPlaceholder = `${this.$t('message.validator.input', { input: this.$t('message.transfer.amount').toLowerCase() })}`;
      // }
      if (!v) {
        return;
      }
      this.debounceGetFee({ isReverse: false, amount: v });
    },
    inputGetHandler(value) {
      let v = value.match(/^\d*(\.?\d{0,2})/g)[0];
      if (`${CURRENCY_DECIMAL_DIGITS[this.form.getCurrency.value]}` === '0') {
        // 不存在小数位时，移除
        v = v.split('.')[0];
      }
      this.form.getAmount = v;
      this.$refs.sellRef.inputInnerValue = v;
      this.form.sendAmount = '';
      if (!v) {
        return;
      }
      if (+v === 0) {
        return;
      }
      this.debounceGetFee({ isReverse: true, amount: v });
    },
    async getFee({ isReverse = false, amount }) {
      if (this.transferMethodList.length === 0) {
        ShowErrorMessage(this.$t('message.transfer.noTransferMethodTips'));
        return;
      }
      if (!this.payoutMethod) {
        return;
      }
      if ((!(+this.form.sendAmount) && !(this.form.getAmount))) {
        return;
      }
      if (+this.form.sendAmount && !isValidCurrencyAmount(this.form.sendAmount, this.form.sendCurrency.value)) {
        return;
      }
      if (+this.form.getAmount && !isValidCurrencyAmount(this.form.getAmount, this.form.getCurrency.value)) {
        return;
      }
      // if (!isReverse && (!this.form.sendAmount || (Number(this.form.sendAmount) > Number(this.form.sendCurrency.amount)))) {
      //   return;
      // }
      if (this.contactInfo) {
        // this.loading = true;
        const SUB_PRODUCT_MAP = {
          0: 'WITHDRAW',
          1: 'PAYMENT',
          2: 'VAT_PAYMENT',
        };
        const params = {
          subProduct: SUB_PRODUCT_MAP[(+this.contactInfo.accountBelong)], // 收款人所属0,1,2
          // paymentMethod: getEnantiomericValue(PAYMENT_METHOD_OPTIONS, this.contactInfo.paymentMethod), // 支付方式 0, 1
          paymentMethod: 'SWIFT',
          cardBinCountry: this.contactInfo.bankCountry,
          reverseFlag: isReverse ? 'Y' : 'N',
          sourceAmount: {
            amount: this.form.sendAmount,
            currency: this.form.sendCurrency.value,
          },
          targetAmount: {
            amount: this.form.getAmount,
            currency: this.form.getCurrency.value,
          },
          receiveMethod: this.payoutMethod,
        };

        try {
          const res = await TransferService.getTransferResult(params);
          this.form.serviceFee = Math.abs(+res.serviceCharge);
          this.form.rate = res.exchangedRate;

          // this.form.serviceFee = res;
          // if (isReverse) {
          //   this.form.sendAmount = this.getMoney(amount, Math.abs(+res));
          // } else {
          //   const ag = this.getMoney(amount, res);
          //   this.form.getAmount = ag > 0 ? ag : '';
          // }
          // this.form.exchangeAmount = this.form.sendAmount - Math.abs(this.form.serviceFee);

          this.form.exchangeAmount = res.exchangedAmount;
          if (isReverse) {
            this.form.sendAmount = formatAmountByCurrency(res.targetAmount, this.form.sendCurrency.value);
          } else {
            this.form.getAmount = formatAmountByCurrency(res.targetAmount, this.form.getCurrency.value);
          }
          this.$refs.formRef1.validateField('sendAmount');

          if (this.showRate && this.rateCountdown === 0) { // 通过判断汇率是否变更进行倒计时, 目前仅通过倒计时是否为 0 来判断
            this.onCountdown();
          }
        } catch (err) {
          //
        }
        this.exchangeDirection = isReverse ? 1 : 0;
      }
    },
    async submit() {
      try {
        await this.$refs.formRef1.validate();
        if (`${this.app.userLogin.merchantStatus}` === '4') { // 未启用时，弹出提示
          this.$bus.$emit('showAuditStatusAlert');
          return;
        }
        if (Number(this.form.sendAmount) > Number(this.form.sendCurrency.amount)) {
          ShowErrorMessage(this.$t('message.transfer.insufficientBalance'));
          return;
        }
        if (this.transferMethodList.length === 0) {
          ShowErrorMessage(this.$t('message.transfer.noTransferMethodTips'));
          return;
        }
        if (this.txnFieldList.length === 0) {
          ShowErrorMessage(this.$t('message.transfer.noTransferFieldsTips'));
          return;
        }

        let payoutForm;
        if (this.payoutMethod === 'BANK_TRANSFER') {
          payoutForm = this.$refs.bankInfoRef;
        } else if (this.payoutMethod === 'E_WALLET') {
          payoutForm = this.$refs.walletInfoRef;
        } else if (this.payoutMethod === 'CASH_PICKUP') {
          payoutForm = this.$refs.cashInfoRef;
        } else if (this.payoutMethod === 'SWIFT') {
          payoutForm = this.$refs.swiftInfoRef;
        }
        let payoutData = {};
        if (payoutForm) {
          payoutData = await payoutForm.getValidateData();
        }
        if (!payoutData) {
          return;
        }
        const payerData = await this.$refs.formRef3.getFormJson();
        console.log(payerData, 'payerData');
        this.$refs.formRef2.toFormValid((data) => {
          const submitData = { ...data, ...this.form };
          submitData.cardInfoId = this.cardInfoId;
          submitData.transactionPurposeText = getEnantiomericValue(this.txnPurposeList, submitData.transactionPurpose);
          submitData.merchantType = this.merchantType;
          submitData.payerInfo = null;
          submitData.payerId = payerData.payerId;
          submitData.isSamePayee = 'N';
          if (this.isPayerChecked) {
            submitData.isSamePayee = 'Y';
            for (let i = 0; i < this.payerList.length; i++) {
              if (this.form.payer === this.payerList[i].id) {
                submitData.payerInfo = this.payerList[i];
                break;
              }
            }
          }
          submitData.contactInfo = {
            ...(this.contactInfo || {}),
            ...payoutData,
          };
          submitData.isSavePayee = this.isSaveContactChecked;
          submitData.payoutMethod = this.payoutMethod;
          submitData.exchangeDirection = this.exchangeDirection;
          if (this.showRate) {
            submitData.showRate = this.showRate;
            submitData.rateExpireTime = Date.now() + this.rateCountdown * 1000;
          }
          console.log(submitData, 'submitData');
          window.sessionStorage.setItem('transferData', JSON.stringify(submitData));
          this.$router.push({
            path: '/transfer/transfer/add/review',
            query: {
              id: this.$route.query.id,
              businessType: this.$route.query.businessType,
            },
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    validateSendAmount(rule, value, callback) {
      // if (Number(this.form.sendAmount) > Number(this.form.sendCurrency.amount)) {
      //   callback(new Error(this.$t('message.transfer.insufficientBalance')));
      //   return;
      // }
      if (this.form.sendAmount && Number(this.form.sendAmount) > 0 && Number(this.form.sendAmount) <= Math.abs(Number(this.form.serviceFee))) {
        callback(new Error(this.$t('message.transfer.moreThanFee')));
        return;
      }
      if (this.form.sendAmount && Number(this.form.sendAmount) > 0 && !isValidCurrencyAmount(this.form.sendAmount, this.form.sendCurrency.value)) {
        callback(new Error(this.$t('message.transfer.currencyAmountTips', { currency: this.form.sendCurrency.value })));
        return;
      }
      callback();
    },
    validateGetAmount(rule, value, callback) {
      if (this.form.getAmount && Number(this.form.getAmount) > 0 && !isValidCurrencyAmount(this.form.getAmount, this.form.getCurrency.value)) {
        callback(new Error(this.$t('message.transfer.currencyAmountTips', { currency: this.form.getCurrency.value })));
        return;
      }
      callback();
    },
    getMoney(amount, fee) {
      let r1, r2;
      try { r1 = `${amount}`.split('.')[1].length; } catch (e) { r1 = 0; };
      try { r2 = `${fee}`.split('.')[1].length; } catch (e) { r2 = 0; };
      const m = Math.pow(10, Math.max(r1, r1));
      const n = r1 > r2 ? r1 : r2;
      return ((Number(amount) * m + Number(fee) * m) / m).toFixed(n);
    },
    validatePayoutForm() {
      let payoutForm;
      if (this.payoutMethod === 'BANK_TRANSFER') {
        payoutForm = this.$refs.bankInfoRef;
      } else if (this.payoutMethod === 'E_WALLET') {
        payoutForm = this.$refs.walletInfoRef;
      } else if (this.payoutMethod === 'CASH_PICKUP') {
        payoutForm = this.$refs.cashInfoRef;
      } else if (this.payoutMethod === 'SWIFT') {
        payoutForm = this.$refs.swiftInfoRef;
      }
      let valid = true;
      if (payoutForm) {
        valid = payoutForm.validate();
      }
      if (!valid) { // 校验不通过，则不选中
        this.isSaveContactChecked = false;
      }
      return valid;
    },
    validateSubmit() {
      if (this.merchantType === 'B2B' && this.isPayerChecked && !this.form.payer) {
        return false;
      }
      if (!this.form.sendAmount || !this.form.getAmount || Number(this.form.sendAmount) <= 0 || Number(this.form.getAmount) <= 0) {
        return false;
      }
      if (!isValidCurrencyAmount(this.form.sendAmount, this.form.sendCurrency.value)) {
        return false;
      }
      if (!isValidCurrencyAmount(this.form.getAmount, this.form.getCurrency.value)) {
        return false;
      }
      if (!this.validatePayoutForm()) {
        return false;
      }
      const data = this.$refs.formRef2.getFormJson();
      for (let i = 0; i < this.conditions.length; i++) {
        const item = this.conditions[i];
        if (!item.isHide) {
          if (item.validator && !item.validator(null, data[item.key])) {
            return false;
          } else if (item.isShowStar && !data[item.key]) {
            return false;
          }
        }
      }
      return true;
    },
    handlePrevious() {
      this.$router.go(-1);
    },
    getCountryDesc(code) {
      if (!code) {
        return '';
      }
      return getEnantiomericValue(this.countryList, code);
    },
    getCardNumber(cardNumber) {
      try {
        if (!cardNumber) {
          return '';
        }
        if (cardNumber.indexOf('*') > -1) { // 已打码
          return cardNumber;
        }
        return `${cardNumber.substr(0, 6)}******${cardNumber.substr(-4)}`;
      } catch (err) {
        //
      }
      return cardNumber;
    },
    onCountdown() {
      this.rateCountdown = 59;
      this.timer = setInterval(() => {
        this.rateCountdown -= 1;
        if (this.rateCountdown <= 0) {
          clearInterval(this.timer);
          this.timer = null;
          const isReverse = this.exchangeDirection === 1;
          this.getFee({ isReverse, amount: isReverse ? this.form.getAmount : this.form.sendAmount });
        }
      }, 1000);
    },
    // 检测是否可以换汇
    async checkRate() {
      if (this.transferMethodList.length === 0) {
        return;
      }
      if (this.form.sendCurrency.value === this.form.getCurrency.value) {
        return;
      }
      if (this.contactInfo) {
        const SUB_PRODUCT_MAP = {
          0: 'WITHDRAW',
          1: 'PAYMENT',
          2: 'VAT_PAYMENT',
        };
        const params = {
          subProduct: SUB_PRODUCT_MAP[(+this.contactInfo.accountBelong)], // 收款人所属0,1,2
          // paymentMethod: getEnantiomericValue(PAYMENT_METHOD_OPTIONS, this.contactInfo.paymentMethod), // 支付方式 0, 1
          paymentMethod: 'SWIFT',
          cardBinCountry: this.contactInfo.bankCountry,
          reverseFlag: 'N',
          sourceAmount: {
            amount: 0,
            currency: this.form.sendCurrency.value,
          },
          targetAmount: {
            amount: 0,
            currency: this.form.getCurrency.value,
          },
          receiveMethod: this.payoutMethod,
        };

        await TransferService.getTransferResult(params);
      }
    },
    async handlePayoutMethod(index) {
      if (index === this.payoutMethod) {
        return;
      }
      this.payoutMethod = index;
      await this.getFee({ isReverse: this.exchangeDirection === 1 });
    },
    isFieldRequired(key) {
      let required = false;
      for (let i = 0; i < this.txnFieldList.length; i++) {
        if (this.txnFieldList[i].key === key) {
          required = this.txnFieldList[i].field === 'Y';
          break;
        }
      }
      return required;
    },
    validateTransactionPurpose(rule, value, callback = () => { }) {
      if (this.isFieldRequired('transactionPurpose') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return false;
      }
      callback();
      return true;
    },
    validateReference(rule, value, callback = () => { }) {
      const bankCountry = this.contactInfo.bankCountry;
      if (this.isFieldRequired('reference') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return false;
      }
      if (!value) {
        callback();
        return true;
      }
      if (!ENGLISH_NAME.regExp.test(value)) {
        callback(new Error(this.$t('message.validator.inputEnglish')));
        return false;
      }
      // Indonesia：String (1-35)
      // Thailand：String (1-140)
      // Vietnam：字段长度限制为max 43位(可能会被visa加上“REM FROM OVERSEA”- 占位16）。建议限定String (1-25)
      // Canada：String (1-19)
      // SEPA：String (1-140)
      // Brazil：String (1-106)
      // Mexico：String (1-30)
      // 其他国家 - 200字符（含）以内
      if (bankCountry === 'ID' && value.length > 35) {
        callback(new Error(this.$t('message.validator.inputLength', { length: '[1-35]' })));
        return false;
      }
      if (bankCountry === 'TH' && value.length > 140) {
        callback(new Error(this.$t('message.validator.inputLength', { length: '[1-140]' })));
        return false;
      }
      if (bankCountry === 'VN' && value.length > 25) {
        callback(new Error(this.$t('message.validator.inputLength', { length: '[1-25]' })));
        return false;
      }
      if (bankCountry === 'CA' && value.length > 19) {
        callback(new Error(this.$t('message.validator.inputLength', { length: '[1-19]' })));
        return false;
      }
      if (bankCountry === 'BR' && value.length > 106) {
        callback(new Error(this.$t('message.validator.inputLength', { length: '[1-106]' })));
        return false;
      }
      if (bankCountry === 'MX' && value.length > 30) {
        callback(new Error(this.$t('message.validator.inputLength', { length: '[1-30]' })));
        return false;
      }
      if (this.euCountryMap[bankCountry] && value.length > 140) {
        callback(new Error(this.$t('message.validator.inputLength', { length: '[1-140]' })));
        return false;
      }
      if (value.length > 200) {
        callback(new Error(this.$t('message.validator.inputLength', { length: '[1-200]' })));
        return false;
      }
      callback();
      return true;
    },
  },
};
</script>
<style lang="scss" scope>
@import '@/styles/variables.scss';

.exchange-form {
  margin-top: -68px;
}

.payout-top-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 80px;
  border-radius: 2px;
  border: 2px solid #9CBAEC;
  margin-bottom: 20px;
  margin-top: 60px;
  box-sizing: border-box;
  padding-left: 18px;
  padding-right: 20px;

  .contact-info-title {
    font-size: 16px;
    font-weight: bold;
    color: $color-text-primary;
    line-height: 22px;

    .name {
      font-size: 18px;
    }
  }

  .contact-info-desc {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-size: 14px;
    color: $color-text-primary;
    line-height: 20px;
    font-weight: bold;

    .contact-country {
      display: flex;
      align-items: center;

      .icon-currency {
        width: 16px;
        height: 16px;
      }
    }
  }
}

.form-relactive {
  .rate-wrapper {
    width: 100%;
    position: relative;
    height: 103px;
    overflow: hidden;

    &.show-rate {
      height: 129px;

      .line {
        height: 129px;
      }
    }

    .line {
      width: 3px;
      height: 103px;
      background: $color-default;
      display: inline-block;
      margin: 0 0 0 22px;
      padding: 0;
      border: 0;
    }

    .rate-content {
      position: absolute;
      left: 12px;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      flex-direction: column;

      .rate-content-item {
        display: flex;
        align-items: center;
        width: 100%;

        .close-icon {
          display: inline-block;
          width: 23px;
          height: 23px;
          background: $color-default;
          border-radius: 50%;
          text-align: center;
          line-height: 23px;

          .el-icon-minus {
            line-height: 23px;
            font-weight: bold;
          }
        }

        .rate-text {
          display: flex;
          margin-left: 13px;
          align-items: center;

          .rate-amount {
            font-size: 14px;
            font-weight: bold;
            line-height: 23px;
            min-width: 85px;
          }

          .time {
            margin-left: 32px;
            font-size: 14px;
            font-weight: 400;
            line-height: 23px;

            .countdown {
              color: $color-text-default-button;
            }
          }
        }
      }
    }
  }

  .transfer-tips {
    font-size: 14px;
    font-weight: 400;
    color: $color-text-primary;
    line-height: 20px;
  }
}

.payer-check-label {
  color: $color-text-primary;
  font-weight: 800;
}

.payout-method-box {
  .payout-method-title {
    font-size: 14px;
    color: $color-text-primary;
    line-height: 20px;
    font-weight: bold;
  }

  .payout-method-list {
    display: flex;
    align-items: center;

    .payout-method-item {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 44px;
      border: 2px solid #D3DADD;
      border-left: none;
      font-size: 14px;
      color: $color-text-primary;
      line-height: 20px;
      font-weight: bold;
      cursor: pointer;

      &:first-child {
        border-left: 2px solid #D3DADD;
        border-radius: 2px 0px 0px 2px;
        box-shadow: none !important;
      }

      &:last-child {
        border-radius: 0px 2px 2px 0px;
      }

      &.checked {
        border-color: $color-primary;
        box-shadow: -2px 0 0 0 $color-primary;
      }
    }
  }
}

.bottom-box-center {
  display: flex;
  flex-direction: column;
  align-items: center;

  .btn-previous {
    cursor: pointer;
    color: $color-text-default-button;
    font-weight: 600;
  }
}
</style>
